var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.route.storeonlinetmreport") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{ pageName, list: ['LIST'] }",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlinetmreport.input.retailerId"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerId },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "retailerId", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlinetmreport.input.retailerName"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "retailerName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sfe.storeonlinetmreport.input.empNo"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.srEmpNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "srEmpNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sfe.storeonlinetmreport.input.empName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.srEmpName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "srEmpName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: {
                        label: _vm.$t("sfe.storeonlinetmreport.input.month"),
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          clearable: "",
                          type: "month",
                          "value-format": "yyyyMM",
                          placeholder: _vm.$t("common.selectDatetime"),
                        },
                        model: {
                          value: _vm.searchVal.month,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchVal, "month", $$v)
                          },
                          expression: "searchVal.month",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "retailerId",
                  label: _vm.$t("sfe.storeonlinetmreport.retailerId"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerName",
                  label: _vm.$t("sfe.storeonlinetmreport.retailerName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("sfe.storeonlinetmreport.empNo"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("sfe.storeonlinetmreport.empName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderScanInRtmQty",
                  label: _vm.$t("sfe.storeonlinetmreport.orderScanInRtmQty"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unOrderScanInRtmQty",
                  label: _vm.$t("sfe.storeonlinetmreport.unOrderScanInRtmQty"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appFinishedSalesQty",
                  label: _vm.$t("sfe.storeonlinetmreport.appFinishedSalesQty"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "warrantyApprovedQty",
                  label: _vm.$t("sfe.storeonlinetmreport.warrantyApprovedQty"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "warrantyToBeReviewedQty",
                  label: _vm.$t(
                    "sfe.storeonlinetmreport.warrantyToBeReviewedQty"
                  ),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unWarrantyApprovedQty",
                  label: _vm.$t(
                    "sfe.storeonlinetmreport.unWarrantyApprovedQty"
                  ),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }